import * as React from 'react';
import { ReadOutlined } from '@ant-design/icons';
import { Avatar, List } from 'antd';
import { getElementAttributes } from '../../helpers/getNodeAttributes';
import { RuleEditorAdd } from './RuleEditorAdd';
import { RuleEditorEdit } from './RuleEditorEdit';
import { RuleEditorDelete } from './RuleEditorDelete';
import { RuleEditorNodeProps, RULE_NODE_COLORS } from '.';

export function RuleEditorCourseGroup(props: RuleEditorNodeProps) {
  const attributes = getElementAttributes(props.elt);
  const description = <><strong>True if:</strong> {attributes.match === 'any' ? 'any child is true' : 'all children are true'}{attributes.validFor && (<><strong> Valid For: </strong><span>{attributes.validFor} year{attributes.validFor !== '1' && 's'}</span></>)}</>;

  return (
    <List.Item
      style={{ padding: '0.25em' }}
      actions={props.editable ? [
        <RuleEditorAdd {...props} key="Add" />,
        <RuleEditorEdit {...props} key="Edit" />,
        <RuleEditorDelete {...props} key="Delete" />,
      ] : undefined}
    >
      <List.Item.Meta avatar={<Avatar icon={<ReadOutlined />} style={{ backgroundColor: RULE_NODE_COLORS.CourseGroup }} />} title="Course Group" description={description} />
    </List.Item>
  );
}
